const allowedKeys = [
  'access_token',
  'refresh_token',
  '.client_id',
  'chatOpen',
  'public_id'
]

const clearLocalStorage = () => {
  allowedKeys.forEach(item => {
    localStorage.removeItem(item)
  })
}

export default clearLocalStorage
